export default __webpack_public_path__ + "static/media/i018sp.e95b2e10.webp";